import React from 'react';
import { ConfigurationProps } from './types';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import './devex_typeahead_custom_styles.scss';

const TypeaheadSelectBootstrap5 = (props: ConfigurationProps) => {
  const config = {
    clearButton: true,
    highlightOnlyResult: true,
    caseSensitive: false,
    minLength: 0,
    multiple: false,
    placeholder: 'Enter search',
    labelKey: 'text',
    ...props,
  };

  config.className = props.multiple
    ? 'devex-typeahead-d9212f65-98be-4a3e-ae7b-8f0229dd7325'
    : 'devex-typeahead-d9212f65-98be-4a3e-ae7b-8f0229dd7325 devex-typeahead-single-select';

  return (
    <>
      <Typeahead {...config} />
      {config.isInvalid && config.invalidFeedback && (
        <div className='invalid-feedback'>
          <span className='fal small icon-times me-2' />
          {config.invalidFeedback}
        </div>
      )}
    </>
  );
};

export default TypeaheadSelectBootstrap5;
